import { UserRole } from '~/api/subscription/subscription-schema';
import { AppRouteSections } from '~/routes/app-routes-constants';

const BASIC_PAGES = [
  AppRouteSections.PORTFOLIO,
  AppRouteSections.ANALYZE,
  AppRouteSections.MY_ACCOUNT,
  AppRouteSections.EXPLORE,
  AppRouteSections.MY_TOGGLE,
  AppRouteSections.SUPPORT,
  AppRouteSections.POSITIONS,
  AppRouteSections.GEN_AI,
  AppRouteSections.CHARTV2,
];

export const RBACRules: Record<UserRole, AppRouteSections[]> = {
  [UserRole.Pro]: [
    ...BASIC_PAGES,
    AppRouteSections.CHART,
    AppRouteSections.SCENARIO,
  ],
  [UserRole.Copilot]: [...BASIC_PAGES, AppRouteSections.CHART],
  [UserRole.Basic]: BASIC_PAGES,
};
